import React from "react";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import ShipmentLine from "./ShipmentLine";
import { OrderSummary, PickUpStatus } from "gpc-shared-types";
import ProductLine from "./ProductLine";
import classNames from "classnames";
import PickupProgress from "./PickupProgress";

export type OrderLineProps = OrderSummary;

const OrderLine: React.FC<OrderLineProps> = ({
  id,
  name,
  poNumber,
  lineItems = [],
  totalPriceSet: { presentmentMoney: totalPrice },
  processedAt,
  meta,
  hasMoreLineItems,
}: OrderLineProps) => {
  let legacyResourceId = id.split("/");
  let resorceIdWithKey = legacyResourceId[legacyResourceId.length - 1];
  let resorceIdWithKeyArray = resorceIdWithKey.split("?");
  let resorceId = resorceIdWithKeyArray[0];
  let shipments = meta?.shipments || [];
  const pickupStatus = meta?.pickupStatus;

  let isBeingFulfilled =
    shipments[0] &&
    shipments[0]?.events.some((event) => event.type === "TRACKING_PROVIDED");

  const cancelReturnButtonClassName = classNames("gpc__button", {
    "gpc__button--is-disabled": isBeingFulfilled,
  });

  if (!shipments) return null;

  console.log("Order Details =>", shipments);

  return (
    <div className="gpc__order-line">
      <div
        style={{
          height: "8px",
          width: "100%",
          backgroundColor: "#A3A3A3",
        }}
      />
      <div className="gpc__order-line__header">
        <div className="gpc__order-line__header-item">
          <h4 className="title">Order</h4>
          <p className="value">{name}</p>
        </div>
        {poNumber && (
          <div className="gpc__order-line__header-item">
            <h4 className="title">PO</h4>
            <p className="value">{poNumber}</p>
          </div>
        )}
        <div className="gpc__order-line__header-item">
          <h4 className="title">Date</h4>
          <p className="value">
            {format(new Date(processedAt), "d MMMM yyyy")}
          </p>
        </div>
        <div className="gpc__order-line__header-item">
          <h4 className="title">Total</h4>
          <p className="value">
            {totalPrice.currencyCode} {totalPrice.amount}
          </p>
        </div>
      </div>
      <div className="gpc__order-line__content">
        <div className="gpc__order-line__controls">
          <Link
            to={`/orders/${resorceId}`}
            className="gpc__button gpc__button--is-active"
          >
            View order details
          </Link>
          {/* <Link to={`/orders/${resorceId}/return-cancel`} className={cancelReturnButtonClassName}>
            Return or cancel item
          </Link> */}
        </div>
        <div className="gpc__order-line__body">
          {lineItems.map((item) => (
            <ProductLine
              {...item}
              key={item.id}
              currencyCode={totalPrice.currencyCode}
            />
          ))}
          {hasMoreLineItems && (
            <div className="gpc__order-line-more-line-items">
              Showing first 10 items only
            </div>
          )}
        </div>
        {pickupStatus && pickupStatus !== PickUpStatus.NONE ? (
          <PickupProgress status={pickupStatus} />
        ) : shipments[0] ? (
          <ShipmentLine shipment={shipments[0]} />
        ) : null}
      </div>
    </div>
  );
};

export default OrderLine;
